// extracted by css-extract-rspack-plugin
export default {"icon":"icon-Wg9b8V","image":"image-aF890y"};